import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';

import {Competencia} from '@modelo/catalogo/Competencia.model';

@Component(
    {
        selector: 'competencia',
        templateUrl: './competencia.template.html',
        styleUrls: ['./competencia.component.scss']
    })

export class CompetenciaComponent implements AfterViewInit {
    dataTable!: Array<any>;
    dataTableInactivos!: Array<any>;

    public entidad: Competencia;

    public abierto!: boolean;
    public animacion!: string;
    public errorActivo!: boolean;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new Competencia();
        this.uriApi = "configuracion/competencia/buscar";
        this.GenerarFiltros()

        this.onReorder = this.onReorder.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
    }


    ngAfterViewInit() {
        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Nombre corto',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nombre'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    Editar(e: Competencia) {
        this.entidad = new Competencia(e);
        this.Modal();
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
    }

    CerrarModal() {
        this.entidad = new Competencia();
        this.animacion = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar() {
        this.errorActivo = true;

        if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un nombre");
        }
        if (!this.entidad.color || !this.entidad.color.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un color");
        }
        if (!this.entidad.descripcion || !this.entidad.descripcion.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una descripción");
        }

        let data = new Competencia(this.entidad)
        this.appService.Post("configuracion/competencia", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                this.CerrarModal();
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        })
    }

    Eliminar(e: Competencia) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracion/competencia/" + e.competenciaid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

    onCellPrepared(e: any) {
        if (e.column.type == "drag" && e.rowType == "data" && !e.data.activo) {
            e.cellElement.style.visibility = 'hidden';
        }
    }

    onDragStart(e: any) {
        this.dataTableInactivos = this.dataTable.filter(x => !x.activo);
        this.dataTable = this.dataTable.filter(x => x.activo);

    }
    onDragEnd(e: any) {
        //this.dataTable = [... this.dataTable, ... this.dataTableInactivos];
    }

    onReorder(e: any) {
        const dataCone: Competencia[] = [];
        this.dataTable.forEach(val => dataCone.push(Object.assign({}, val)));

        const visibleRows = e.component.getVisibleRows();
        const toIndex = this.dataTable.findIndex((item) => item.orden === visibleRows[e.toIndex].data.orden);
        const fromIndex = this.dataTable.findIndex((item) => item.orden === e.itemData.orden);

        this.dataTable.splice(fromIndex, 1);
        this.dataTable.splice(toIndex, 0, e.itemData);
        this.setOrden();

        let opciones = this.sistemaService.GetOpcionesConfirmar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Deseas guardar el orden?', opciones).then(res => {
            if (res == 1) {
                let dataOrdenada = this.dataTable.map((x: Competencia) => {
                    return {competenciaid: x.competenciaid, orden: x.orden}
                })
                this.appService.Put("configuracion/competencia", dataOrdenada).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                }).catch(err => {
                    this.dataTable = [...dataCone, ... this.dataTableInactivos];
                })

                this.dataTable = [...this.dataTable, ... this.dataTableInactivos];
            } else {
                this.dataTable = [...dataCone, ... this.dataTableInactivos];
            }
        })

    }

    setOrden() {
        this.dataTable.forEach((x: Competencia, i: number) => {
            x.orden = i + 1;
        })
    }

}
